import React from "react";
import cx from "classnames";

const propTypes = {};

const CLASS_ROOT = "input-addons__item";

const Addon = ({ className, ...other }) => {
  const classes = cx(CLASS_ROOT, className);

  return <div className={classes} {...other} />;
};

Addon.displayName = "Addon";
Addon.propTypes = propTypes;

export default Addon;
